import React from 'react';
import times from 'lodash/times';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../CommonComponents/OPL/Shimmer/Shimmer';
import { Separator } from '../CommonComponents/OPL/Separator/Separator';

export const ContactAdvisorLoading = () => {
  return (
    <>
      <Box display="flex" alignItems="center" p="16" css="gap: 16px">
        <Shimmer width={64} height={64} isRound />

        <Shimmer width={120} height={20} />
      </Box>

      <Box mb={80}>
        {times(4).map(key => (
          <>
            <Box key={key} display="flex" alignItems="center" p="24" css="gap: 12px">
              <Shimmer width={16} height={16} />

              <Shimmer width={250} height={20} />
            </Box>

            <Separator />
          </>
        ))}
      </Box>
    </>
  );
};
